import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromCollections from '../reducers/museum-collections.reducer';
import { MuseumCollection } from '../../models';
import * as fromRoot from '../../../store';

export const getMuseumCollectionState = createSelector(fromFeature.getMuseumState, (state: fromFeature.ContentState) => state.collections);

export const getMuseumCollectionEntities = createSelector(getMuseumCollectionState, fromCollections.getMuseumCollectionsEntities);

export const getAllMuseumCollections = createSelector(getMuseumCollectionEntities, entities => {
  return Object.keys(entities).map(id => entities[id as unknown as number]).sort((a, b) => a.order - b.order);
});

export const getMuseumCollectionsOverviewLoaded = createSelector(getMuseumCollectionState, fromCollections.getMuseumCollectionsOverviewLoaded);
export const getMuseumCollectionsOverviewLoading = createSelector(getMuseumCollectionState, fromCollections.getMuseumCollectionsOverviewLoading);

export const getMuseumCollectionsLoaded = createSelector(getMuseumCollectionState, fromCollections.getMuseumCollectionsLoaded);
export const getMuseumCollectionsLoading = createSelector(getMuseumCollectionState, fromCollections.getMuseumCollectionsLoading);

export const getSelectedMuseumCollection = createSelector(getMuseumCollectionEntities, fromRoot.getRouterState, (entities, router): MuseumCollection => {
  return router.state && entities[+router.state.params?.['collectionId'] || +router.state.data?.['collectionId']];
});

export const getOtherMuseumCollections = createSelector(getAllMuseumCollections, fromRoot.getRouterState, (entities, router): MuseumCollection[] => {
  const id = +router.state.params?.['collectionId'] || +router.state.data?.['collectionId'];
  return entities.filter(collection => collection.id !== id);
});

export const getSelectedMuseumCollectionLoading = createSelector(getMuseumCollectionsLoading, fromRoot.getRouterState, (loading, router): boolean => {
  return router.state && loading.includes(+router.state.params?.['collectionId'] || +router.state.data?.['collectionId']);
});

export const getSelectedMuseumCollectionLoaded = createSelector(getMuseumCollectionsLoaded, fromRoot.getRouterState, (loaded, router): boolean => {
  return router.state && loaded.includes(+router.state.params?.['collectionId'] || +router.state.data?.['collectionId']);
});
